export const BOTTOM = 'bottom';
export const LEFT = 'left';
export const RIGHT = 'right';
export const TOP = 'top';
export const MIDDLE = 'middle';
export const BOTTOM_LEFT = `${BOTTOM}-${LEFT}`;
export const BOTTOM_MIDDLE = `${BOTTOM}-${MIDDLE}`;
export const BOTTOM_RIGHT = `${BOTTOM}-${RIGHT}`;
export const TOP_LEFT = `${TOP}-${LEFT}`;
export const TOP_MIDDLE = `${TOP}-${MIDDLE}`;
export const TOP_RIGHT = `${TOP}-${RIGHT}`;
export const PLACEMENT_OPTIONS = [
  BOTTOM_LEFT,
  BOTTOM_MIDDLE,
  BOTTOM_RIGHT,
  LEFT,
  RIGHT,
  TOP_LEFT,
  TOP_MIDDLE,
  TOP_RIGHT,
];

export default {
  BOTTOM,
  LEFT,
  RIGHT,
  TOP,
  MIDDLE,
  BOTTOM_LEFT,
  BOTTOM_MIDDLE,
  BOTTOM_RIGHT,
  TOP_LEFT,
  TOP_MIDDLE,
  TOP_RIGHT,
  PLACEMENT_OPTIONS,
};
